import {Component, HostBinding, OnDestroy, OnInit} from '@angular/core';
import {routeAnimation} from '../../../route.animation';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {FormsService} from '../../../_services/forms.service';
import {Subscription} from 'rxjs/Subscription';
import {ActivatedRoute, Params} from '@angular/router';
import {DateAdapter, MAT_DATE_FORMATS} from '@angular/material/core';
import {APP_DATE_FORMATS, CustomDateAdapter} from '../../../_pipes/angular2-material-datepicker-custom-date';
import {PreviousUrlService} from '../../../_services/previous-url.service';
import {ReportsService} from '../../../_services/reports.service';
import {Reports} from '../../../_interfaces/reports/reports';
import {Client} from '../../../_interfaces/clients/clients';
import {ReportsQuestions} from '../../../_interfaces/reports/reports-questions';
import {ClientsService} from '../../../_services/clients.service';
import {ApiService} from '../../../_interceptors/api.service';
import {ServerResponse} from '../../../_interfaces/server.response';
import {AuthenticationService} from '../../../_services/authentication.service';
import {User} from '../../../_interfaces/user';
import {PageTitleService} from '../../../_services/page-title.service';
import {environment} from '../../../../environments/environment';

@Component({
	selector: 'app-reports-closed-questionnaire',
	templateUrl: './reports-questionnaire.component.html',
	styleUrls: ['./reports-questionnaire.component.scss'],
	animations: [routeAnimation],
	providers: [
		{
			provide: DateAdapter, useClass: CustomDateAdapter
		},
		{
			provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS
		}
	]
})

export class ReportsClosedQuestionnaireComponent implements OnInit, OnDestroy {
	@HostBinding('@routeAnimation') routerTransition = true;

	public report_id: number = null;
	public report_type: string = null;
	public dataLoaded: boolean = false;
	public missingData: Array<string> = [];
	public reportEditable: boolean = false;

	public report: Reports = null;
	public client: Client = null;
	public questionnaire: ReportsQuestions[] = [];

	public reportQuestionnaireForm = this.formBuilder.group({
		questions: this.formBuilder.group([])
	});

	private _errorsSubscription: Subscription = null;
	private _activatedRouteSubscription: Subscription = null;
	private _authenticationServiceSubscription: Subscription = null;

	constructor(private reportsService: ReportsService,
				private authenticationService: AuthenticationService,
				private apiService: ApiService,
				private clientsService: ClientsService,
				public formsService: FormsService,
				private activatedRoute: ActivatedRoute,
				private formBuilder: FormBuilder,
				private previousUrlService: PreviousUrlService,
				private pageTitleService: PageTitleService) {
	}

	ngOnInit(): void {
		this.apiService.connectionChanged.subscribe(online => {
			if (online && this.missingData.length) {
				this.missingData = [];
				this.loadData();
			}
		});

		this.formsService.form = this.reportQuestionnaireForm;

		this._errorsSubscription = this.reportsService.errors.subscribe(errors => {
			this.formsService.processErrors(errors);
		});

		this._activatedRouteSubscription = this.activatedRoute.params.subscribe((params: Params) => {
			this.report_type = params['report_type'];
			this.report_id = parseInt(params['report_id'], 10);

			this.reportsService.getReport(this.report_type, this.report_id).then((report: Reports) => {
				this._authenticationServiceSubscription = this.authenticationService.user.first().subscribe((user: User) => {
					if (typeof report !== 'undefined' && typeof user !== 'undefined') {

						this.pageTitleService.setTitle(report.report_nr + ' | Rapportage inspectieschema | ' + environment.webappName);
						this.pageTitleService.setPageTitle(report.report_nr);

/*
						if (report.status !== 'closed') {
							if (typeof report.edit_lock !== 'undefined' && typeof report.edit_lock_user_id !== 'undefined') {
								if (report.edit_lock === true && (<any>report.edit_lock_user_id === '' ||
									report.edit_lock_user_id === null ||
									report.edit_lock_user_id === 0 ||
									report.edit_lock_user_id === user.id ||
									user.type === 'kvvm-admin')) {
									this.reportEditable = true;
								}
							}
						}
*/
					}
				});
			});

			this.previousUrlService.setPreviousUrlIfNull('/reports/' + this.report_type + '/' + this.report_id + '/closed/view');

			this.loadData();
		});
	}

	ngOnDestroy(): void {
		if (this._activatedRouteSubscription !== null) {
			this._activatedRouteSubscription.unsubscribe();
		}

		if (this._errorsSubscription !== null) {
			this._errorsSubscription.unsubscribe();
		}

		if (this._authenticationServiceSubscription !== null) {
			this._authenticationServiceSubscription.unsubscribe();
		}
	}

	loadData() {
		this.reportsService.getClosedReports(this.report_type, this.report_id).then((data: ServerResponse) => {
			console.log(data);
			if (typeof data !== 'undefined') {
				if (typeof data.data !== 'undefined') {
					if (typeof data.data[0] !== 'undefined') {
						this.report = <Reports>data.data[0];

						this.clientsService.getClient(data.data[0].client_id).then((client: Client) => {
							this.client = client;
						});

									this.reportsService.getClosedWarehouseQuestionnaireAnswer(this.report_type, this.report_id).then((answers: ServerResponse) => {
										if (typeof answers !== 'undefined') {
											if (typeof answers.data !== 'undefined') {
												if (typeof answers.data.questionnaire !== 'undefined') {
													console.log(answers.data.questionnaire);
													answers.data.questionnaire.forEach(question_group => {
														let control = <FormGroup>this.reportQuestionnaireForm.get('questions');
														control.addControl('[' + question_group.id + '][status]', new FormControl(question_group.result === '1'));

														if (typeof question_group.questions !== 'undefined') {
															question_group.questions.forEach(question => {
																control.addControl('[' + question_group.id + '][' + question.id + ']', new FormControl(parseInt(question.result, 10)));
															});
														}
														this.questionnaire.push(<ReportsQuestions>question_group);
													});
												}
											}
										}
									});

						this.dataLoaded = true;
					} else {
						this.missingData.push('Rapportage');
					}
				} else {
					this.missingData.push('Rapportage');
				}
			} else {
				this.missingData.push('Rapportage');
			}
		});
	}
}
